module.exports = __webpack_public_path__ + "media/shared/assets/fonts/Rubik/Rubik-Light-9d2ccd264dc61b9540199896728594ab.ttf";